import { QueryClient } from "@tanstack/react-query";

// Instância única fora de qualquer componente para não recriar a cada render
// e para poder ser limpa fora da árvore React (ex: logout em UserContext).
const queryClient = new QueryClient();

export { queryClient };
